import { combineReducers } from 'redux'
import student from './student/reducers/quiz'

const rootReducer = combineReducers({
  student,
})

export default rootReducer
